var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"RightCenter"}},[_c('dv-border-box-13',[_c('HeaderTitle',{attrs:{"title":"货物出入情况"}}),_c('RigthtCenterEarch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }